import React from 'react'
import ProductSlider from './ProductSlider';

function ProductDetails({ product, handleProdQty, handleExtras, handleExtraQty, handleOptions, option }) {
    const { type, options } = product;
    let $option = null;
    if (option) {
        $option = options.find(x => x.id === option);
    } else {
        $option = options[0];
    }
    const calculateTotal = () => {
        let $prodprice = type.discount_price ? type.discount_price * product.qty : type.price * product.qty;
        let $extraPrice = 0;
        product.currentExtras.map((extra) => {
            const $price = product.type.extras.find(x => x.id === extra.id).price * extra.qty;
            return $extraPrice += $price;
        });
        return ($prodprice + $extraPrice).toFixed(2);
    }

    let total_price = calculateTotal();
    const updateExtras = (id) => {
        handleExtras(id);
        calculateTotal();
    }
    const updateOptions = (val) => {
        handleOptions(val);
        calculateTotal();
    }
    const updateExtraQty = (event, id) => {
        // console.log(event, id, $val);
        let $val = event.value;
        handleExtraQty(id, $val);
        calculateTotal();
    }
    const updateProdQty = (val) => {
        handleProdQty(val);
        calculateTotal();
    }
    const getQtyOptions = ($method, $xtra) => {
        let $markup = '';
        let $maximum = 0;
        switch ($method) {
            case 'prod':
                $maximum = product.type.maxQty;
                break;
            case 'extra':
                let $xtraItem = product.type.extras.find(x => x.id === $xtra)
                $maximum = $xtraItem.maxQty;
                break;
        }
        for (let $i = 1; $i <= $maximum; $i++) {
            $markup += `<option value="${$i}">Qty ${$i}</option>`
        }
        return { __html: $markup };
    }
    return (
        <div className="card payments-card mb-2" id="theProd">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12 col-lg-3">
                        <div className="equipment first-equip text-center">
                            <ProductSlider product={product.id} />
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-5">
                        <div className="equipment middle-equip">
                            <div className="title">
                                <select name="prod_qty" defaultValue={product.qty} onChange={(e) => updateProdQty(e.target.value)} defaultChecked={product.qty} className="form-control form-control-sm" dangerouslySetInnerHTML={getQtyOptions('prod')}></select>
                                <h6 className="prod_title">{product.name}  <span> {type.name}:
                                ${type.discount_price ? type.discount_price.toFixed(2) : type.price.toFixed(2)}<sub className="small-text">{type.name === 'lease' ? '/mo.' : ''}</sub>
                                </span>
                                </h6>
                            </div>

                            {options.length > 0 ?
                                <>
                                    <div className="option_selector">
                                        {options.map((val, i) => {
                                            return (
                                                <div key={val.id} className="option_wrap">
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" defaultChecked={option === val.id} onClick={() => updateOptions(val.id)} name="option" id={'option' + val.id} value={val.id} className="radios custom-control-input" />
                                                        <label className="custom-control-label" htmlFor={'option' + val.id}><span>{val.name}</span>
                                                            <small className="d-block">
                                                                ${val.price.toFixed(2)} {val.price_type ? ' - ' + val.price_type : ''}
                                                            </small>
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <hr />
                                </>
                                :
                                ''
                            }
                            <div className="extras-wrap">
                                {type.extras.map((extra) => {
                                    return (
                                        <div className="extra-item" key={extra.id}>

                                            <div className="options">
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" defaultChecked={product.currentExtras.find(x => x.id === extra.id)} className="radios custom-control-input" id={'extra' + extra.id} name="extra[]" onChange={() => updateExtras(extra.id)} />
                                                    <label className="custom-control-label" htmlFor={'extra' + extra.id}>
                                                        <span>{extra.name}:</span>
                                                        <br /> Add ${extra.price.toFixed(2)} {type.name === 'Lease' ? 'per month' : ''} each
                                                {product.currentExtras.find(x => x.id === extra.id) ?
                                                            <select name="prod_qty" defaultValue={product.currentExtras.find(x => x.id === extra.id).qty} onChange={(e) => updateExtraQty(e.target, extra.id)} className="form-control form-control-sm" dangerouslySetInnerHTML={getQtyOptions('extra', extra.id)}></select>
                                                            : ''}
                                                    </label>
                                                </div>




                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4">
                        <div className="equipment final-equip">
                            <div className="table-responsive">
                                <table className="table table-sm"
                                    id="equip_overview">
                                    <tbody>
                                        <tr className="product_row">
                                            <td width="45">{product.qty}x</td>
                                            <td scope="row">{product.name}</td>
                                            <td className="text-right">$<span className="price">{type.discount_price ? type.discount_price.toFixed(2) : type.price.toFixed(2)} </span></td>
                                        </tr>

                                        {product.currentExtras.length ?
                                            <tr>
                                                <td colSpan={3} className="text-center font-weight-bold">Extras</td>
                                            </tr> : null
                                        }
                                        {product.type.extras.map((extra) => {
                                            if (product.currentExtras.find(x => x.id === extra.id)) {
                                                return (
                                                    <tr key={extra.id} className="product_row">
                                                        <td>{product.currentExtras.find(x => x.id === extra.id).qty}x</td>
                                                        <td scope="row">{extra.name}</td>
                                                        <td className="text-right">$<span className="price">{extra.price.toFixed(2)}</span></td>
                                                    </tr>
                                                )
                                            }
                                            return null;
                                        })}

                                        <tr className="totals">
                                            <th colSpan="2">{type.name === 'lease' ? 'Monthly Lease' : 'One Time Total'}:</th>
                                            <th className="text-right">${total_price}</th>
                                        </tr>
                                        {$option && $option.price > 0 ?
                                            <tr className="product_row fee">
                                                <th colSpan="2" scope="row">{$option.name} fee:</th>
                                                <td className="text-right">$<span className="price">{$option.price.toFixed(2)}</span></td>
                                            </tr>
                                            : <tr></tr>}
                                    </tbody>


                                </table>
                                <p className="text-center charge_note">
                                    Please note: You will not be charged until your account is approved!
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    )
}

export default ProductDetails
